import React, { useState, useEffect } from 'react';
import MUIDataTable from "mui-datatables";
import { connect } from "react-redux";
import * as proposalService from "../../../../services/service/proposalService";
import * as alert from "../../../../redux/alertSnackBarRedux";
import * as confirmModal from "../../../../redux/confirmModalRedux";
import { Link, NavLink } from "react-router-dom";
import { dateFilterListRenderer, dateFilterLogic } from "../../../../helpers/helper";
import { Nav, Tab, Spinner, Modal, Form, Button } from "react-bootstrap";
import DateFilterComponent from '../../../components/DateFilterComponent';
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";

const ProposalListingPage = (props) => {
    const { showAlert, showConfirmModal, hideConfirmModal, setProcessing } = props;

    const proposalToRejectInitialState = {
        projectNumber: '',
        proposalId: 0,
        rejectionReason: ''
    }

    const [loading, setLoading] = useState(false);
    const [proposals, setProposals] = useState([]);
    const [secondTableProposals, setSecondTableProposals] = useState([]);
    const [status, setStatus] = useState("unassigned");
    const [isRejectionModalOpen, setIsRejectionModalOpen] = useState(false);
    const [proposalToReject, setProposalToReject] = useState(proposalToRejectInitialState);

    useEffect(() => {
        loadProposalsForSecondTable();
        loadProposals(status);
    }, [status]);

    const loadProposals = () => {
        setLoading(true);
        proposalService.GetProposals(status).then(res => {
            setProposals(res);
        }).catch((ex) => {
            showAlert({ message: ex.message, variant: "error" });
        }).finally(x => setLoading(false));
    }

    const loadProposalsForSecondTable = () => {
        setLoading(true);
        proposalService.GetProposals("SENT-TO-CLIENT").then(res => {
            setSecondTableProposals(res);
        }).catch((ex) => {
            showAlert({ message: ex.message, variant: "error" });
        }).finally(x => setLoading(false));
    }

    const deleteProposal = (proposalId) => {
        proposalService.DeleteProposal(proposalId).then(res => {
            showAlert({ message: res.message, variant: "success" });
            hideConfirmModal();
        })
    }

    const handleRejectionModalClose = () => {
        setIsRejectionModalOpen(false);
        setProposalToReject(proposalToRejectInitialState);
    }

    const handleProposalRejection = () => {
        proposalService.RejectProposal(proposalToReject).then(res => {
            loadProposalsForSecondTable();
            showAlert({ message: res.message, variant: 'success' });
            handleRejectionModalClose();
        }).catch(ex => {
            showAlert({ message: ex.message, variant: 'error' })
        })
    }

    const handleProposalApproval = (proposalId) => {
        setProcessing();
        proposalService.ApproveProposal(proposalId).then(res => {
            loadProposalsForSecondTable();
            showAlert({ message: res.message, variant: 'success' });
        }).catch(ex => {
            showAlert({ message: ex.message, variant: 'error' })
        }).finally(() => hideConfirmModal());
    }

    const handleProposalRevision = (proposalId) => {
        setProcessing();
        proposalService.ReviseProposal(proposalId).then(res => {
            loadProposalsForSecondTable();
            showAlert({ message: res.message, variant: 'success' });
        }).catch(ex => {
            showAlert({ message: ex.message, variant: 'error' })
        }).finally(() => hideConfirmModal());
    }

    const getRejectionReason = (proposalId, projectNumber) => {
        proposalService.GetRejectionReason(proposalId).then(res => {
            setProposalToReject({
                projectNumber: projectNumber,
                proposalId: proposalId,
                rejectionReason: '',
                savedRejectionReason: res.rejectionReason
            });

            setIsRejectionModalOpen(true);
        });
    }

    const proposalsColumn = [
        {
            name: "id",
            label: "Actions",
            options: {
                filter: false,
                sort: false,
                width: 1,
                download: false,
                print: false,
                customBodyRenderLite: (dataIndex) => {
                    return (
                        <div className="flex-container">
                            <NavLink
                                to={{
                                    pathname: "/services/manage-proposal/" + proposals[dataIndex].id,
                                    state: { proposalId: proposals[dataIndex].id }
                                }}
                                className="btn btn-sm btn-info font-weight-bold font-size-sm mr-3"
                            >
                                Edit
                            </NavLink>
                            <button
                                className={`btn btn-danger btn-sm font-weight-bold font-size-sm mr-3`}
                                onClick={() => showConfirmModal({
                                    title: "Delete Proposal",
                                    text: "Are you sure you want to delete this proposal?",
                                    rightBtnText: "Confirm",
                                    btnAction: () => deleteProposal(proposals[dataIndex].id, false)
                                })}
                            >
                                Delete
                            </button>
                        </div>
                    );
                }
            },

        },
        {
            name: "projectNumber",
            label: "Project #",
            options: {
                filter: true,
                filterType: 'multiselect',
                sort: true,
                setCellProps: () => ({ style: { width: "10%" } }),
                customBodyRenderLite: (dataIndex) =>
                (
                    <Link to={{
                        pathname: "/services/manage-proposal/" + proposals[dataIndex].id,
                        state: { proposalId: proposals[dataIndex].id }
                    }}>
                        {proposals[dataIndex].projectNumber}
                    </Link>
                )
            }
        },
        {
            name: "client",
            label: "Client",
            options: {
                filter: true,
                filterType: 'multiselect',
                sort: true,
            }
        },
        // {
        //     name: "location",
        //     label: "Location",
        //     options: {
        //         filter: true,
        //         filterType: 'multiselect',
        //         sort: true,
        //     }
        // },
        {
            name: "projectType",
            label: "Project Type",
            options: {
                filter: true,
                filterType: 'multiselect',
                sort: true,
            }
        },
        {
            name: "projectSubType",
            label: "Project Sub Type",
            options: {
                filter: true,
                filterType: 'multiselect',
                sort: true,
            }
        },
        {
            name: "createdBy",
            label: "Created By",
            options: {
                filter: true,
                filterType: 'multiselect',
                sort: true,
            }
        },
        {
            name: "expiryDate",
            label: "Expiry Date",
            options: {
                display: status !== "reviewed",
                filter: true,
                sort: true,
                filterType: 'custom',
                customFilterListRender: v => dateFilterListRenderer(v),
                filterOptions: {
                    names: [],
                    logic(date, filters) {
                        return dateFilterLogic(date, filters);
                    },
                    display: (filterList, onChange, index, column) => <DateFilterComponent
                        name={"Expiry Date"}
                        filterList={filterList}
                        onChange={onChange}
                        index={index}
                        column={column}
                    />
                }
            }
        }
    ];

    const proposalsSecondTableColumn = [
        {
            name: "id",
            label: "Actions",
            options: {
                filter: true,
                sort: true,
                download: false,
                customBodyRenderLite: (dataIndex) => {
                    return (
                        <div className="flex-container">
                            {
                                secondTableProposals[dataIndex].isApproved === false ?
                                    <>
                                        <button
                                            onClick={() => getRejectionReason(secondTableProposals[dataIndex].id, secondTableProposals[dataIndex].projectNumber)}
                                            className="btn btn-sm btn-info font-weight-bold font-size-sm mr-3"
                                        >
                                            View Rejection Reason
                                        </button>
                                    </> :
                                    <>
                                        <button
                                            className="btn btn-sm btn-primary font-weight-bold font-size-sm mr-3"
                                            disabled={secondTableProposals[dataIndex].isApproved !== null}
                                            onClick={() => secondTableProposals[dataIndex].isApproved === null ? showConfirmModal({
                                                title: "Approve Proposal",
                                                text: "Are you sure you want to approve this proposal?",
                                                rightBtnText: "Confirm",
                                                btnAction: () => handleProposalApproval(secondTableProposals[dataIndex].id)
                                            }) : {}}
                                        >
                                            Approved
                                        </button>
                                        <button
                                            className="btn btn-sm btn-warning font-weight-bold font-size-sm mr-3"
                                            onClick={() => showConfirmModal({
                                                title: "Revise Proposal",
                                                text: "Are you sure you want to revise this proposal?",
                                                rightBtnText: "Confirm",
                                                btnAction: () => handleProposalRevision(secondTableProposals[dataIndex].id)
                                            })}
                                        >
                                            Revise
                                        </button>
                                        <button
                                            disabled={secondTableProposals[dataIndex].isApproved !== null}
                                            onClick={() => {
                                                if (secondTableProposals[dataIndex].isApproved === null) {
                                                    setProposalToReject({
                                                        proposalId: secondTableProposals[dataIndex].id,
                                                        rejectionReason: "",
                                                        projectNumber: secondTableProposals[dataIndex].projectNumber,
                                                    });
                                                    setIsRejectionModalOpen(true);
                                                }
                                            }}
                                            className={`btn btn-danger btn-sm font-weight-bold font-size-sm mr-3`}
                                        >
                                            Rejected
                                        </button>
                                    </>
                            }
                        </div>
                    );
                }
            }
        },
        {
            name: "projectNumber",
            label: "Project #",
            options: {
                filter: true,
                filterType: 'multiselect',
                sort: true,
                setCellProps: () => ({ style: { width: "10%" } }),
                customBodyRenderLite: (dataIndex) =>
                (
                    <Link to={{
                        pathname: "/services/manage-proposal/" + secondTableProposals[dataIndex].id,
                        state: { proposalId: secondTableProposals[dataIndex].id }
                    }}>
                        {secondTableProposals[dataIndex].projectNumber}
                    </Link>
                )
            }
        },
        {
            name: "client",
            label: "Client",
            options: {
                filter: true,
                filterType: 'multiselect',
                sort: true,
            }
        },
        // {
        //     name: "location",
        //     label: "Location",
        //     options: {
        //         filter: true,
        //         filterType: 'multiselect',
        //         sort: true,
        //     }
        // },
        {
            name: "projectType",
            label: "Project Type",
            options: {
                filter: true,
                filterType: 'multiselect',
                sort: true,
            }
        },
        {
            name: "projectSubType",
            label: "Project Sub Type",
            options: {
                filter: true,
                filterType: 'multiselect',
                sort: true,
            }
        },
        {
            name: "createdBy",
            label: "Created By",
            options: {
                filter: true,
                filterType: 'multiselect',
                sort: true,
            }
        },
        {
            name: "isApproved",
            label: "Is Approved",
            options: {
                filter: true,
                filterType: 'multiselect',
                sort: true,
                customBodyRenderLite: (dataIndex) => {
                    return (
                        <>
                            {
                                secondTableProposals[dataIndex].isApproved === null ?
                                    <p>Pending</p> :
                                    <SVG
                                        className="h-50 align-self-center"
                                        src={toAbsoluteUrl(secondTableProposals[dataIndex].isApproved ? "/media/svg/icons/Navigation/Check.svg" : "/media/svg/icons/Navigation/Close.svg")}
                                    >
                                    </SVG>
                            }
                        </>
                    );
                }
            }
        }
    ];

    return (
        <div className="row" >
            <Modal centered size="lg" show={isRejectionModalOpen} onHide={handleRejectionModalClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Rejection Reason for Project #{proposalToReject.projectNumber}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {
                        proposalToReject.savedRejectionReason ?
                            <p>{proposalToReject.savedRejectionReason}</p> :
                            <div className="form-group row">
                                <div className="col-lg-12 col-xl-12">
                                    <label>Please enter the rejection reason in the text box below</label>
                                </div>
                                <div className="col-lg-12 col-xl-12">
                                    <div className="input-group input-group-lg input-group-solid">
                                        <Form.Control as="textarea" rows="7"
                                            placeholder="Enter Rejection Reason"
                                            className={`form-control form-control-lg form-control-solid`}
                                            name="rejectionReason"
                                            value={proposalToReject.rejectionReason}
                                            onChange={e => setProposalToReject({ ...proposalToReject, rejectionReason: e.target.value })}
                                        />
                                    </div>
                                </div>
                            </div>
                    }
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleRejectionModalClose}>
                        Close
                    </Button>
                    {!proposalToReject.savedRejectionReason && <button
                        type="submit"
                        className="btn btn-success mr-2"
                        disabled={
                            proposalToReject.rejectionReason.length === 0
                        }
                        onClick={handleProposalRejection}
                    >
                        Submit Rejection
                    </button>}
                </Modal.Footer>
            </Modal>

            <div className="col-lg-12 col-xxl-12 mb-10">
                <div className={`card card-custom card-stretch gutter-b}`}>
                    <div className={`card card-custom card-stretch gutter-b`}>
                        <div className="card-header border-0 pt-5">
                            <h3 className="card-title align-items-start flex-column">
                                <span className="card-label font-weight-bolder text-dark">
                                    Pending Proposals
                                </span>
                                <span className="text-muted mt-3 font-weight-bold fz-xs">
                                    View proposals that are still pending or being reviewed to be sent to clients.
                                </span>
                            </h3>
                            <div className="card-toolbar">
                                <Tab.Container defaultActiveKey={status}>
                                    <Nav
                                        as="ul"
                                        onSelect={_status => setStatus(_status)}
                                        className="nav nav-pills nav-pills-sm nav-dark-75"
                                    >
                                        <Nav.Item className="nav-item" as="li">
                                            <Nav.Link
                                                eventKey="unassigned"
                                                className={`nav-link py-2 px-4 ${status === "unassigned" ? "active" : ""}`}
                                            >
                                                Pending Review
                                            </Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item className="nav-item" as="li">
                                            <Nav.Link
                                                eventKey="pending-review"
                                                className={`nav-link py-2 px-4 ${status === "pending-review" ? "active" : ""}`}
                                            >
                                                Review In Progress
                                            </Nav.Link>
                                        </Nav.Item>
                                    </Nav>
                                </Tab.Container>
                            </div>
                        </div>
                        <div className="container-fluid">
                            <MUIDataTable
                                data={proposals}
                                columns={proposalsColumn}
                                options={{
                                    rowsPerPage: 50,
                                    rowsPerPageOptions: [10, 15, 20, 25, 30, 35, 40, 45, 50, 100],
                                    selectableRows: 'none',
                                    textLabels: {
                                        body: {
                                            noMatch: loading ?
                                                <Spinner animation="border" size="lg" variant="info" /> :
                                                'Sorry, no matching records found.',
                                        },
                                    }
                                }}
                            />
                        </div>
                    </div>
                </div>
            </div>


            <div className="col-lg-12 col-xxl-12">
                <div className={`card card-custom card-stretch gutter-b}`}>
                    <div className="card-header border-0 pt-10">
                        <h3 className="card-title align-items-start flex-column">
                            <span className="card-label font-weight-bolder text-dark">
                                Submitted Proposals
                            </span>
                            <span className="text-muted mt-3 font-weight-bold fz-xs">
                                View all proposals sent to clients.
                            </span>
                        </h3>
                    </div>
                    <div className="container-fluid mt-lg-10">
                        <MUIDataTable
                            data={secondTableProposals}
                            columns={proposalsSecondTableColumn}
                            options={{
                                rowsPerPage: 50,
                                rowsPerPageOptions: [10, 15, 20, 25, 30, 35, 40, 45, 50, 100],
                                selectableRows: 'none',
                                textLabels: {
                                    body: {
                                        noMatch: loading ?
                                            <Spinner animation="border" size="lg" variant="info" /> :
                                            'Sorry, no matching records found.',
                                    },
                                }
                            }}
                        />
                    </div>
                </div>
            </div>

        </div >
    )
}

export default connect(null, { ...alert.actions, ...confirmModal.actions })(ProposalListingPage);